import React, { useState } from "react";
import { Button, Modal } from "antd";
import "./style.css";
import { ErrorDeactivate } from "../../../assets/icons";
import { httpService } from "../../../base/services/httpService.service";
import { useNotification } from "../../../base/hooks/useNotification";
import { useNavigate } from "react-router-dom";
import AuthService from "../../../base/services/authentication.service";
import { useTranslation } from "../../../i18n/LanguageContext";

const ConfirmAccDeletionDeactivation = ({
   openConfirmDeactivation,
   onCancel,
   title,
   description,
   otherDesc,
   button,
   action,
   formData
}) => {
   const { t } = useTranslation();
   const { api: notificationApi, notificationContextHolder } = useNotification();
   const navigate = useNavigate();
   const [loadingDeactivate, setLoadingDeactivate] = useState(false);
   const [loadingDelete, setLoadingDelete] = useState(false);
   const [user, setUser] = useState(AuthService.getUser());

   const logout = () => {
      AuthService.logout();
   };
   const handleDeleteORDeactivate = async () => {
      const payload = {
         reason: formData.reason,
         description: formData.description
      };

      try {
         if (action === "delete") {
            setLoadingDelete(true);
            const deleteUserPayload = {
               userId: user?.id,
               ...payload
            };
            await httpService.delete(`/Accounts`, { data: deleteUserPayload }, (res) => {
               logout();
               navigate(`/auth/account?action=${action}`);
            });
         } else if (action === "deactivate") {
            setLoadingDeactivate(true);
            await httpService.put(
               "/Accounts/deactivate",
               payload,
               (res) => {
                  logout();
                  navigate(`/auth/account?action=${action}`);
               },
               () => {}
            );
         }
      } catch (error) {
         notificationApi.error("user", {
            message: t("generic-problem-occurred-title"),
            description:
               action === "delete"
                  ? t("delete-account-error-description")
                  : t("deactivate-account-error-description")
         });
      } finally {
         if (action === "delete") {
            setLoadingDelete(false);
         } else {
            setLoadingDeactivate(false);
         }
      }
   };

   return (
      <>
         {notificationContextHolder}
         <Modal
            open={openConfirmDeactivation}
            onCancel={onCancel}
            maskClosable={!loadingDelete || !loadingDeactivate}
            className="modalContainer"
            destroyOnClose
            footer={[]}
            // closable={false}
         >
            <div className="d-flex flex-column">
               <div className="d-flex align-items-center flex-column" style={{ gap: "16px" }}>
                  <div className="d-flex justify-content-center align-items-center innerSection">
                     <img src={ErrorDeactivate} alt="error icon" />
                     <span className="title-span">{title}</span>
                  </div>
                  <span className="span-description-action">
                     {description} <strong>{otherDesc}</strong>
                  </span>
               </div>
            </div>
            <div className="footer-buttons">
               <Button className="cancel-deactivation" onClick={onCancel}>
                  {t("cancel")}
               </Button>
               <Button
                  className="deactivate-button"
                  loading={action === "delete" ? loadingDelete : loadingDeactivate}
                  onClick={handleDeleteORDeactivate}
               >
                  {button}
               </Button>
            </div>
         </Modal>
      </>
   );
};

export default ConfirmAccDeletionDeactivation;
